module.exports = __webpack_public_path__ + "img/vision_03_2x.f16b391c.jpg";